import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import DistributionType from "../../../Models/Catalogue/Classifications/DistributionType";

export default class DistributionTypeCatalogueEntry extends CatalogueEntry<DistributionType> {

    constructor() {
        super("Distribution Types", DistributionType);
    }

    public get editRole() {
        return CatalogueRoles.DistributionType.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.distributionTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveDistributionTypes;
    }

    public renderRow(item: DistributionType, meta: Model.TransformMetaType<DistributionType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.name} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        ); 
    }
}